module.exports = __webpack_public_path__ + "img/pauli-y-root-11.46613cd9.svg";